export const ROW_EXPAND = 'ROW_EXPAND';
export const rowExpand = (id, expanded, basePath) => ({
  type: ROW_EXPAND,
  payload: { id, expanded, basePath },
});
